import type { IconData } from '@stacksjs/iconify-core'

export const commentAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21 22a1 1 0 0 1-.707-.293L16.586 18H5a3.003 3.003 0 0 1-3-3V5a3.003 3.003 0 0 1 3-3h14a3.003 3.003 0 0 1 3 3v16a1 1 0 0 1-1 1\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default commentAlt
